import { InjectionToken } from '@angular/core';

export const ZAPPDEV_WINDOW = new InjectionToken<Window>('Window');
export const ZAPPDEV_DOCUMENT = new InjectionToken<Document>('Document');
